import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IPlasiyerHome_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPlasiyerHome_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  GetPlasiyereBagliCariler: any[];
  GetPlasiyereBagliCariler_dummy: any[];
  GetPlasiyerBekleyenTeklifler: any[];
  GetPlasiyerBekleyenTeklifler_dummy: any[];
  PlasiyerOnayBekleyenSip: any[];
  PlasiyerOnayBekleyenSip_dummy: any[];
  PlasiyerOnayBekleyenTeklifler: any[];
  PlasiyerOnayBekleyenTeklifler_dummy: any[];
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  PlasiyerCariSepetOzeti: any[];
  PlasiyerCariSepetOzeti_dummy: any[];
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  InsertTeklifTemp: number;
  InsertTeklifTemp_dummy: number;
  WriteToSessionStorage: any;
  WriteToSessionStorage_dummy: any;
  isComp566106Visible: "visible" | "hidden";
}

export class PlasiyerHome_ScreenBase extends React.PureComponent<
  IPlasiyerHome_ScreenProps,
  any
> {
  plasiyerhome_341430_value_kuikaTableRef: React.RefObject<any>;
  plasiyerhome_498324_value_kuikaTableRef: React.RefObject<any>;
  plasiyerhome_956484_value_kuikaTableRef: React.RefObject<any>;
  plasiyerhome_471009_value_kuikaTableRef: React.RefObject<any>;
  plasiyerhome_722777_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 328636,
          PropertyName: "value",
          Value: "Pending Offers",
          TagName: "Label3_value",
        },
        {
          Id: 86316,
          PropertyName: "value",
          Value: "Currents",
          TagName: "Label11_value",
        },
        {
          Id: 28031,
          PropertyName: "title",
          Value: "Current Name",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 767526,
          PropertyName: "title",
          Value: "User name",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 19011,
          PropertyName: "title",
          Value: "Offer No.",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 682986,
          PropertyName: "title",
          Value: "Situation",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 866365,
          PropertyName: "title",
          Value: "Other",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 346879,
          PropertyName: "title",
          Value: "Current Code",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 140457,
          PropertyName: "title",
          Value: "Current Name",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 426491,
          PropertyName: "title",
          Value: "Other",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 836009,
          PropertyName: "title",
          Value: "Order Date",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 310450,
          PropertyName: "title",
          Value: "Order Number",
          TagName: "TableTemplateColumn13_title",
        },
        {
          Id: 361567,
          PropertyName: "title",
          Value: "Current Name",
          TagName: "TableTemplateColumn15_title",
        },
        {
          Id: 101458,
          PropertyName: "title",
          Value: "Other",
          TagName: "TableTemplateColumn14_title",
        },
        {
          Id: 762640,
          PropertyName: "title",
          Value: "Offer Date",
          TagName: "TableTemplateColumn1_1_title",
        },
        {
          Id: 28899,
          PropertyName: "title",
          Value: "Offer Number",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 772227,
          PropertyName: "title",
          Value: "Current Name",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 107967,
          PropertyName: "title",
          Value: "Other",
          TagName: "TableTemplateColumn11_title",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [],
    },
    {
      Id: "07c0a6b9-2a2c-4965-a0bd-411813b979cf",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 473501, PropertyName: "label", Value: "Çıkış Yap" },
        {
          Id: 780818,
          PropertyName: "value",
          Value: "Aktarılmayı Bekleyen Siparişler",
        },
        { Id: 397703, PropertyName: "value", Value: "Tanımlı Müşterilerim" },
        {
          Id: 684960,
          PropertyName: "value",
          Value: "İşlem Bekleyen Teklifler",
        },
        {
          Id: 825754,
          PropertyName: "value",
          Value: "Aktarılmayı Bekleyen Teklifler",
        },
        { Id: 762640, PropertyName: "title", Value: "Teklif Tarihi" },
        {
          Id: 965569,
          PropertyName: "value",
          Value: "[datafield:tekliftarihi]",
        },
        { Id: 28899, PropertyName: "title", Value: "Teklif Numarası" },
        {
          Id: 750824,
          PropertyName: "value",
          Value: "[datafield:teklifnumarasi]",
        },
        { Id: 772227, PropertyName: "title", Value: "Cari İsim" },
        { Id: 513988, PropertyName: "value", Value: "[datafield:cari_isim]" },
        { Id: 107967, PropertyName: "title", Value: "Diğer" },
        {
          Id: 718901,
          PropertyName: "value",
          Value: "Aktarılmayı Bekleyen Teklifler",
        },
        { Id: 328636, PropertyName: "value", Value: "Bekleyen Teklifler" },
        { Id: 28031, PropertyName: "title", Value: "Cari Adı" },
        { Id: 18536, PropertyName: "value", Value: "[datafield:cari_isim]" },
        { Id: 767526, PropertyName: "title", Value: "Kullanıcı Adı" },
        { Id: 941618, PropertyName: "value", Value: "[datafield:adsoyad]" },
        { Id: 19011, PropertyName: "title", Value: "Teklif No" },
        {
          Id: 137547,
          PropertyName: "value",
          Value: "[datafield:teklifnumarasi]",
        },
        { Id: 682986, PropertyName: "title", Value: "Durum" },
        { Id: 496878, PropertyName: "value", Value: "[datafield:durum]" },
        { Id: 866365, PropertyName: "title", Value: "Diğer" },
        { Id: 86316, PropertyName: "value", Value: "Müşteri Listesi" },
        { Id: 346879, PropertyName: "title", Value: "Cari Kodu" },
        { Id: 848845, PropertyName: "value", Value: "[datafield:cari_kod]" },
        { Id: 140457, PropertyName: "title", Value: "Cari Adı" },
        { Id: 454900, PropertyName: "value", Value: "[datafield:cari_isim]" },
        { Id: 426491, PropertyName: "title", Value: "Diğer" },
        {
          Id: 463155,
          PropertyName: "value",
          Value: "Aktarılmayı Bekleyen Siparişler",
        },
        { Id: 836009, PropertyName: "title", Value: "Sipariş Tarihi" },
        {
          Id: 181858,
          PropertyName: "value",
          Value: "[datafield:siparistarihi]",
        },
        { Id: 310450, PropertyName: "title", Value: "Sipariş Numarası" },
        {
          Id: 657968,
          PropertyName: "value",
          Value: "[datafield:siparisnumarasi]",
        },
        { Id: 361567, PropertyName: "title", Value: "Cari İsim" },
        { Id: 462997, PropertyName: "value", Value: "[datafield:cari_isim]" },
        { Id: 101458, PropertyName: "title", Value: "Diğer" },
        { Id: 776225, PropertyName: "value", Value: "Cari Sepeti Bekleyenler" },
        { Id: 982969, PropertyName: "title", Value: "Cari Kodu" },
        { Id: 309716, PropertyName: "value", Value: "[datafield:firmakodu]" },
        { Id: 223043, PropertyName: "title", Value: "Cari Adı" },
        { Id: 866984, PropertyName: "value", Value: "[datafield:cari_isim]" },
        { Id: 587245, PropertyName: "title", Value: "Ürün Adedi" },
        { Id: 379817, PropertyName: "value", Value: "[datafield:urunadedi]" },
        { Id: 11231, PropertyName: "title", Value: "Toplam Fiyat" },
        { Id: 992116, PropertyName: "value", Value: "[datafield:parasembol]" },
        { Id: 512225, PropertyName: "value", Value: "[datafield:toplamfiyat]" },
        { Id: 290342, PropertyName: "title", Value: "Diğer" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";
  PlasiyerHomeRecuringAction_15_Interval: any;

  constructor(props) {
    super(props);
    this.plasiyerhome_341430_value_kuikaTableRef = React.createRef();
    this.plasiyerhome_498324_value_kuikaTableRef = React.createRef();
    this.plasiyerhome_956484_value_kuikaTableRef = React.createRef();
    this.plasiyerhome_471009_value_kuikaTableRef = React.createRef();
    this.plasiyerhome_722777_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetKullanici: [],
      GetPlasiyereBagliCariler: [],
      GetPlasiyerBekleyenTeklifler: [],
      PlasiyerOnayBekleyenSip: [],
      PlasiyerOnayBekleyenTeklifler: [],
      GetParametreler: [],
      PlasiyerCariSepetOzeti: [],
      Logout: false,
      goToSignInActivity: "",
      NAVIGATE: "",
      InsertTeklifTemp: 0,
      WriteToSessionStorage: "",
      isComp566106Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("plasiyerhome", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.PlasiyerHomePageInit();
    }

    if (true) {
      if (false) {
        await this.PlasiyerHomeRecuringAction_15_();
      }
      this.PlasiyerHomeRecuringAction_15_Interval = setInterval(async () => {
        await this.PlasiyerHomeRecuringAction_15_();
      }, 15000);
    }

    KuikaAppManager.calculateAndSetBodyHeight("plasiyerhome", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (this.PlasiyerHomeRecuringAction_15_Interval) {
      clearInterval(this.PlasiyerHomeRecuringAction_15_Interval);
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["Plasiyer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("plasiyerhome", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.PlasiyerHomePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  PlasiyerHomePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      PlasiyerKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
      TumCariYetki_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isTumCariYetki
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isTumCariYetki
            : null
        ),
        "boolean"
      ),
      PlasiyerKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
      isTumCariYetki_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isTumCariYetki
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isTumCariYetki
            : null
        ),
        "boolean"
      ),
      plasiyerKodu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
      isTumCariYetki_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isTumCariYetki
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isTumCariYetki
            : null
        ),
        "boolean"
      ),
      PlasiyerKodu_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
      isTumCariYetki_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isTumCariYetki
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isTumCariYetki
            : null
        ),
        "boolean"
      ),
      isTumCariYetki_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isTumCariYetki
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isTumCariYetki
            : null
        ),
        "boolean"
      ),
      isPlasiyerKodu_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerHome/PlasiyerHomePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.plasiyerhome_44862_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    stateVars.GetPlasiyereBagliCariler = result?.data.getPlasiyereBagliCariler;

    formVars.plasiyerhome_308862_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyereBagliCariler !== undefined
        ? stateVars.GetPlasiyereBagliCariler?.length > 0
          ? stateVars.GetPlasiyereBagliCariler[0].toplamKayitSayisi
          : null
        : this.state.GetPlasiyereBagliCariler?.length > 0
        ? this.state.GetPlasiyereBagliCariler[0].toplamKayitSayisi
        : null
    );
    stateVars.GetPlasiyerBekleyenTeklifler =
      result?.data.getPlasiyerBekleyenTeklifler;

    formVars.plasiyerhome_346361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerBekleyenTeklifler !== undefined
        ? stateVars.GetPlasiyerBekleyenTeklifler?.length > 0
          ? stateVars.GetPlasiyerBekleyenTeklifler[0].toplamKayitSayisi
          : null
        : this.state.GetPlasiyerBekleyenTeklifler?.length > 0
        ? this.state.GetPlasiyerBekleyenTeklifler[0].toplamKayitSayisi
        : null
    );
    stateVars.PlasiyerOnayBekleyenSip = result?.data.plasiyerOnayBekleyenSip;

    formVars.plasiyerhome_294675_value = ReactSystemFunctions.toString(
      this,
      stateVars.PlasiyerOnayBekleyenSip !== undefined
        ? stateVars.PlasiyerOnayBekleyenSip?.length > 0
          ? stateVars.PlasiyerOnayBekleyenSip[0].toplamKayitSayisi
          : null
        : this.state.PlasiyerOnayBekleyenSip?.length > 0
        ? this.state.PlasiyerOnayBekleyenSip[0].toplamKayitSayisi
        : null
    );
    stateVars.PlasiyerOnayBekleyenTeklifler =
      result?.data.plasiyerOnayBekleyenTeklifler;

    formVars.plasiyerhome_911974_value = ReactSystemFunctions.toString(
      this,
      stateVars.PlasiyerOnayBekleyenTeklifler !== undefined
        ? stateVars.PlasiyerOnayBekleyenTeklifler?.length > 0
          ? stateVars.PlasiyerOnayBekleyenTeklifler[0].toplamKayitSayisi
          : null
        : this.state.PlasiyerOnayBekleyenTeklifler?.length > 0
        ? this.state.PlasiyerOnayBekleyenTeklifler[0].toplamKayitSayisi
        : null
    );
    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp566106Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.PlasiyerCariSepetOzeti = result?.data.plasiyerCariSepetOzeti;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PlasiyerHomePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerHomePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.plasiyerhome_44862_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.plasiyerhome_294675_value = ReactSystemFunctions.toString(
      this,
      stateVars.PlasiyerOnayBekleyenSip !== undefined
        ? stateVars.PlasiyerOnayBekleyenSip?.length > 0
          ? stateVars.PlasiyerOnayBekleyenSip[0].toplamKayitSayisi
          : null
        : this.state.PlasiyerOnayBekleyenSip?.length > 0
        ? this.state.PlasiyerOnayBekleyenSip[0].toplamKayitSayisi
        : null
    );

    formVars.plasiyerhome_308862_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyereBagliCariler !== undefined
        ? stateVars.GetPlasiyereBagliCariler?.length > 0
          ? stateVars.GetPlasiyereBagliCariler[0].toplamKayitSayisi
          : null
        : this.state.GetPlasiyereBagliCariler?.length > 0
        ? this.state.GetPlasiyereBagliCariler[0].toplamKayitSayisi
        : null
    );

    stateVars.isComp566106Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyerhome_346361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerBekleyenTeklifler !== undefined
        ? stateVars.GetPlasiyerBekleyenTeklifler?.length > 0
          ? stateVars.GetPlasiyerBekleyenTeklifler[0].toplamKayitSayisi
          : null
        : this.state.GetPlasiyerBekleyenTeklifler?.length > 0
        ? this.state.GetPlasiyerBekleyenTeklifler[0].toplamKayitSayisi
        : null
    );

    stateVars.dataSource_341430 =
      stateVars.PlasiyerOnayBekleyenTeklifler ??
      this.state.PlasiyerOnayBekleyenTeklifler;
    formVars.plasiyerhome_911974_value = ReactSystemFunctions.toString(
      this,
      stateVars.PlasiyerOnayBekleyenTeklifler !== undefined
        ? stateVars.PlasiyerOnayBekleyenTeklifler?.length > 0
          ? stateVars.PlasiyerOnayBekleyenTeklifler[0].toplamKayitSayisi
          : null
        : this.state.PlasiyerOnayBekleyenTeklifler?.length > 0
        ? this.state.PlasiyerOnayBekleyenTeklifler[0].toplamKayitSayisi
        : null
    );

    stateVars.dataSource_498324 =
      stateVars.GetPlasiyerBekleyenTeklifler ??
      this.state.GetPlasiyerBekleyenTeklifler;

    stateVars.dataSource_956484 =
      stateVars.GetPlasiyereBagliCariler ?? this.state.GetPlasiyereBagliCariler;

    stateVars.dataSource_471009 =
      stateVars.PlasiyerOnayBekleyenSip ?? this.state.PlasiyerOnayBekleyenSip;

    stateVars.dataSource_722777 =
      stateVars.PlasiyerCariSepetOzeti ?? this.state.PlasiyerCariSepetOzeti;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  PlasiyerHomeComponent_473501_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerHomeComponent_133568_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifDetay",
      "TeklifNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_341430_value",
          "teklifNumarasi"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifDetay",
      "CariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_341430_value",
          "firmaKodu"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifDetay",
      "ParaSembol",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_341430_value",
          "paraSembol"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifDetay",
      "TalepNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_341430_value",
          "talepNo"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifDetay",
      "Gonderen",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_341430_value",
          "adSoyad"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifDetay",
      "Tarih",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_341430_value",
          "teklifTarihi"
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifDetay",
      "RevizeNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_341430_value",
          "revizeSiraNo"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerHome",
      "PlasiyerTeklifDetay",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "149849",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerHomeComponent_257864_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisLoglari",
      "siparisNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_341430_value",
          "teklifNumarasi"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerHome",
      "SiparisLoglari",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "388764",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerHomeComponent_489577_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_498324_value",
          "teklifNumarasi"
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerHome/PlasiyerHomeComponent_489577_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InsertTeklifTemp = result?.data.insertTeklifTemp;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PlasiyerHomeComponent_489577_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerHomeComponent_489577_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.WriteToSessionStorage =
      await ReactSystemFunctions.writeToSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string"),
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_498324_value",
          "carI_KOD"
        )
      );
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifPage",
      "CariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_498324_value",
          "carI_KOD"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifPage",
      "TeklifNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_498324_value",
          "teklifNumarasi"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerHome",
      "PlasiyerTeklifPage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerHomeComponent_449036_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.WriteToSessionStorage =
      await ReactSystemFunctions.writeToSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string"),
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_956484_value",
          "carI_KOD"
        )
      );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerHome",
      "AnaSayfa",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerHomeComponent_467258_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerSiparisDetay",
      "siparisNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_471009_value",
          "siparisNumarasi"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerSiparisDetay",
      "CariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_471009_value",
          "firmaKodu"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerSiparisDetay",
      "ParaSembol",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_471009_value",
          "paraSembol"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerSiparisDetay",
      "TalepNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_471009_value",
          "talepNo"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerSiparisDetay",
      "Gonderen",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_471009_value",
          "adSoyad"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerSiparisDetay",
      "Tarih",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_471009_value",
          "siparisTarihi"
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerSiparisDetay",
      "SiparisNot",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_471009_value",
          "siparisNot"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerHome",
      "PlasiyerSiparisDetay",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "686908",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerHomeComponent_371101_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisLoglari",
      "siparisNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_471009_value",
          "siparisNumarasi"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerHome",
      "SiparisLoglari",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "717654",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerHomeComponent_498058_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.WriteToSessionStorage =
      await ReactSystemFunctions.writeToSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string"),
        ReactSystemFunctions.value(
          this,
          "plasiyerhome_722777_value",
          "firmaKodu"
        )
      );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerHome",
      "SiparisOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerHomeRecuringAction_15_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      PlasiyerKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
      isTumCariYetki_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isTumCariYetki
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isTumCariYetki
            : null
        ),
        "boolean"
      ),
      plasiyerKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
      isTumCariYetki_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isTumCariYetki
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isTumCariYetki
            : null
        ),
        "boolean"
      ),
      PlasiyerKodu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
      isTumCariYetki_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isTumCariYetki
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isTumCariYetki
            : null
        ),
        "boolean"
      ),
      isTumCariYetki_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isTumCariYetki
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isTumCariYetki
            : null
        ),
        "boolean"
      ),
      isPlasiyerKodu_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
    };

    if (false) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerHome/PlasiyerHomeRecuringAction_15_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.plasiyerhome_44862_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    stateVars.GetPlasiyerBekleyenTeklifler =
      result?.data.getPlasiyerBekleyenTeklifler;

    formVars.plasiyerhome_346361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerBekleyenTeklifler !== undefined
        ? stateVars.GetPlasiyerBekleyenTeklifler?.length > 0
          ? stateVars.GetPlasiyerBekleyenTeklifler[0].toplamKayitSayisi
          : null
        : this.state.GetPlasiyerBekleyenTeklifler?.length > 0
        ? this.state.GetPlasiyerBekleyenTeklifler[0].toplamKayitSayisi
        : null
    );
    stateVars.PlasiyerOnayBekleyenSip = result?.data.plasiyerOnayBekleyenSip;

    formVars.plasiyerhome_294675_value = ReactSystemFunctions.toString(
      this,
      stateVars.PlasiyerOnayBekleyenSip !== undefined
        ? stateVars.PlasiyerOnayBekleyenSip?.length > 0
          ? stateVars.PlasiyerOnayBekleyenSip[0].toplamKayitSayisi
          : null
        : this.state.PlasiyerOnayBekleyenSip?.length > 0
        ? this.state.PlasiyerOnayBekleyenSip[0].toplamKayitSayisi
        : null
    );
    stateVars.PlasiyerOnayBekleyenTeklifler =
      result?.data.plasiyerOnayBekleyenTeklifler;

    formVars.plasiyerhome_911974_value = ReactSystemFunctions.toString(
      this,
      stateVars.PlasiyerOnayBekleyenTeklifler !== undefined
        ? stateVars.PlasiyerOnayBekleyenTeklifler?.length > 0
          ? stateVars.PlasiyerOnayBekleyenTeklifler[0].toplamKayitSayisi
          : null
        : this.state.PlasiyerOnayBekleyenTeklifler?.length > 0
        ? this.state.PlasiyerOnayBekleyenTeklifler[0].toplamKayitSayisi
        : null
    );
    stateVars.PlasiyerCariSepetOzeti = result?.data.plasiyerCariSepetOzeti;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PlasiyerHomeRecuringAction_15_1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerHomeRecuringAction_15_1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.plasiyerhome_44862_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.plasiyerhome_294675_value = ReactSystemFunctions.toString(
      this,
      stateVars.PlasiyerOnayBekleyenSip !== undefined
        ? stateVars.PlasiyerOnayBekleyenSip?.length > 0
          ? stateVars.PlasiyerOnayBekleyenSip[0].toplamKayitSayisi
          : null
        : this.state.PlasiyerOnayBekleyenSip?.length > 0
        ? this.state.PlasiyerOnayBekleyenSip[0].toplamKayitSayisi
        : null
    );

    formVars.plasiyerhome_346361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerBekleyenTeklifler !== undefined
        ? stateVars.GetPlasiyerBekleyenTeklifler?.length > 0
          ? stateVars.GetPlasiyerBekleyenTeklifler[0].toplamKayitSayisi
          : null
        : this.state.GetPlasiyerBekleyenTeklifler?.length > 0
        ? this.state.GetPlasiyerBekleyenTeklifler[0].toplamKayitSayisi
        : null
    );

    stateVars.dataSource_341430 =
      stateVars.PlasiyerOnayBekleyenTeklifler ??
      this.state.PlasiyerOnayBekleyenTeklifler;
    formVars.plasiyerhome_911974_value = ReactSystemFunctions.toString(
      this,
      stateVars.PlasiyerOnayBekleyenTeklifler !== undefined
        ? stateVars.PlasiyerOnayBekleyenTeklifler?.length > 0
          ? stateVars.PlasiyerOnayBekleyenTeklifler[0].toplamKayitSayisi
          : null
        : this.state.PlasiyerOnayBekleyenTeklifler?.length > 0
        ? this.state.PlasiyerOnayBekleyenTeklifler[0].toplamKayitSayisi
        : null
    );

    stateVars.dataSource_498324 =
      stateVars.GetPlasiyerBekleyenTeklifler ??
      this.state.GetPlasiyerBekleyenTeklifler;

    stateVars.dataSource_471009 =
      stateVars.PlasiyerOnayBekleyenSip ?? this.state.PlasiyerOnayBekleyenSip;

    stateVars.dataSource_722777 =
      stateVars.PlasiyerCariSepetOzeti ?? this.state.PlasiyerCariSepetOzeti;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      149849,
      388764,
      ,
      ,
      686908,
      717654,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.PlasiyerHomePageInit();
    }
  }
}
